export default __webpack_public_path__ + "static/media/presentation-ipad.0bd584d0.jpg";